import {
  SlIcon
} from "./chunk.O7VCMB7W.js";

// src/components/icon/icon.ts
var icon_default = SlIcon;
SlIcon.define("sl-icon");

export {
  icon_default
};
